/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Speakers_No_SpeakersInputs */

const en_event_speakers_no_speakers = /** @type {(inputs: Event_Speakers_No_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Speaker(s) Assigned`)
};

const fr_event_speakers_no_speakers = /** @type {(inputs: Event_Speakers_No_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun locuteur assigne`)
};

const de_event_speakers_no_speakers = /** @type {(inputs: Event_Speakers_No_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein/e Sprecher/in zugewiesen`)
};

const it_event_speakers_no_speakers = /** @type {(inputs: Event_Speakers_No_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun relatore assegnato`)
};

const ru_event_speakers_no_speakers = /** @type {(inputs: Event_Speakers_No_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Докладчик(и) не назначены`)
};

const es_event_speakers_no_speakers = /** @type {(inputs: Event_Speakers_No_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay oradores asignados`)
};

const zh_cn2_event_speakers_no_speakers = /** @type {(inputs: Event_Speakers_No_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未指定发言人`)
};

const ja_event_speakers_no_speakers = /** @type {(inputs: Event_Speakers_No_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`講演者が割り当てられていません`)
};

const hi_event_speakers_no_speakers = /** @type {(inputs: Event_Speakers_No_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई वक्ता नियुक्त नहीं किया गया है`)
};

const pt_pt2_event_speakers_no_speakers = /** @type {(inputs: Event_Speakers_No_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum palestrante designado`)
};

/**
* | output |
* | --- |
* | "No Speaker(s) Assigned" |
*
* @param {Event_Speakers_No_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_speakers_no_speakers = /** @type {((inputs?: Event_Speakers_No_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Speakers_No_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_speakers_no_speakers(inputs)
	if (locale === "de") return de_event_speakers_no_speakers(inputs)
	if (locale === "it") return it_event_speakers_no_speakers(inputs)
	if (locale === "ru") return ru_event_speakers_no_speakers(inputs)
	if (locale === "es") return es_event_speakers_no_speakers(inputs)
	if (locale === "zh-CN") return zh_cn2_event_speakers_no_speakers(inputs)
	if (locale === "ja") return ja_event_speakers_no_speakers(inputs)
	if (locale === "hi") return hi_event_speakers_no_speakers(inputs)
	if (locale === "pt-PT") return pt_pt2_event_speakers_no_speakers(inputs)
	return en_event_speakers_no_speakers(inputs)
});